export default {
  modals: {
    questionnaire: {
      greeting: {
        title: 'Добро пожаловать в edna Pulse, {{name}}!',
        description:
          'Расскажите нам немного о себе –<br />это поможет нам развивать продукт в нужном направлении',
      },
      skip: 'Пропустить',
      emptyError: 'Пожалуйста, выберите значение',
      job: {
        title: 'В какой отрасли вы работаете?',
        medicine: 'Медицина',
        education: 'Образование',
        groceries: 'Ритейл',
        realEstate: 'Недвижимость',
        services: 'Сфера услуг',
        auto: 'Авто',
        other: 'Другое, до 50 символов',
      },
      role: {
        title: 'Какая у вас роль в компании?',
        marketing: 'Маркетолог',
        salesManager: 'Менеджер по продажам',
        analytic: 'Аналитик',
        developer: 'IT-специалист',
        businessOwner: 'Руководитель / Владелец бизнеса',
        accountant: 'Бухгалтер',
        other: 'Другое, до 50 символов',
      },
      goals: {
        title: 'Какие задачи вы будете решать в личном кабинете?',
        broadcasts: 'настраивать и отправлять рассылки',
        bills: 'оплачивать счета, планировать бюджет на коммуникации',
        broadcastsAnalytics: 'анализировать эффективность рассылок',
        api: 'настраивать и поддерживать API-интеграцию',
        other: 'Другое, до 100 символов',
      },
      people: {
        title: 'Сколько людей у вас в компании?',
        ten: 'До 10',
        hundred: 'От 10 до 100',
        thousand: 'От 100 до 1000',
        moreThanThousand: 'Больше 1000',
      },
      opinion: {
        title: 'Готовы делиться своим мнением?',
        description:
          'Иногда мы хотели бы узнать ваше мнение о продукте, вы смогли бы участвовать в наших опросах?',
        yes: 'Да, давайте',
        no: 'Нет, спасибо',
      },
      success: {
        title: 'Большое спасибо за ваше участие!',
        toProfile: 'Перейти в личный кабинет',
      },
    },
  },
};
